export default __webpack_public_path__ + "static/media/notepad.f131707a.png";